<template>
  <div class="flex flex-direction align-center full-screen">
    <MenuHeader></MenuHeader>
    <div
      class="scroll-y"
      :class="UI.isMobile ? 'full-width' : 'container margin-top-50'"
      :style="UI.isMobile ? 'height: calc(100vh - 70px)' : 'height: calc(100vh - 120px)'"
    >
      <router-view
        v-if="$route.name == 'login' || User.user.role == 1000"
      ></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import MenuHeader from '@/components/menuHeader.vue';
import Footer from '@/components/footer.vue';

export default {
  components: {
    MenuHeader,
  },

  computed: {
    ...mapState(['User', 'UI']),
  },
};
</script>

<style lang="scss">
$container-width: 80%;

.container {
  width: $container-width;
}

.header-container {
  width: $container-width;
}

body{
  background-color: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue